import { getBusinessRegions } from './ApiConfig';

// Business/region/view options are config-driven (/config.json), not hardcoded.
export function businesses(): string[] {
  return Object.keys(getBusinessRegions());
}

export function businessesForView(view: string): string[] {
  const map = getBusinessRegions();
  return Object.keys(map).filter((b) => map[b].views.includes(view));
}

export function regionsForBusiness(business: string): string[] {
  return getBusinessRegions()[business]?.regions ?? [];
}

export function viewsForBusiness(business: string): string[] {
  return getBusinessRegions()[business]?.views ?? [];
}
